// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/_services/auth.service';
import { environment } from '../../../../../environments';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent { 
	notificationBackground: string;

	myLeaders: string[] = ['Jhon Dow'];

	constructor(
		private router: Router,
		private authService: AuthService
	) {
		this.myLeaders = authService.currentUser.leadersName || this.myLeaders;
		this.notificationBackground = environment.assets.notificationBackground		
	}
}
